var lists_default = {
  "fontElementMap": "F86yy",
  "orderedlist": "FI3Pv",
  "bulletedlist": "oCwCb",
  "listItem": "omQtW"
};
export {
  lists_default as default
};
//# sourceMappingURL=lists-scss.js.map
